import styles from './AuditionsPageHeader.module.css';

function AuditionsPageHeader({ onCreateClick }) {
  return (
    <div className={styles.header}>
      <div className={styles.headerLeft}>
        <h1 className={styles.title}>캐스팅 공고</h1>
        <p className={styles.subtitle}>진행 중인 캐스팅 공고를 탐색하고 나에게 맞는 배역을 찾아보세요.</p>
      </div>
      <button className={styles.createBtn} onClick={onCreateClick}>
        <span className={styles.createBtnPlus}>+</span>
        공고 작성
      </button>
    </div>
  );
}

export default AuditionsPageHeader;
